import { render, staticRenderFns } from "./EvaluationDetailModal.vue?vue&type=template&id=67834547&scoped=true"
import script from "./EvaluationDetailModal.vue?vue&type=script&lang=js"
export * from "./EvaluationDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67834547",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67834547')) {
      api.createRecord('67834547', component.options)
    } else {
      api.reload('67834547', component.options)
    }
    module.hot.accept("./EvaluationDetailModal.vue?vue&type=template&id=67834547&scoped=true", function () {
      api.rerender('67834547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/evaluationDetail/modules/EvaluationDetailModal.vue"
export default component.exports